import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class DanceAnimation extends Animation {

    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        const top = item.y - 100;
        const y = item.y;
        const rotation = 15 * Math.PI / 180;
        let sign = 1;
        const onUpdate = () => this.updatePaperCut(item);
        const rotate = (start: boolean) => {
            item.tweenTo(start ? 0.2 : 0.4, Ease.sineInOut, {
                rotation: sign * rotation,
                onUpdate,
            });
        };
        const jump = (start: boolean) => {
            item.y = y;
            item.moveYTo(top, 0.3, Ease.sineInOut, {
                delay: start ? this.delay : undefined,
                onStart: () => {
                    rotate(start);
                    if (start) {
                        cb();
                    }
                },
                repeat: 3,
                yoyo: true,
                onUpdate,
                onComplete: () => {
                    sign = -sign;
                    rotate(false);
                    jump(false);
                },
            });
        };
        jump(true);
    }
}
